import React from "react";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { colors } from "../utils/constants";

interface ButtonLoadingProps {
  isDelete?: boolean;
  style?: React.CSSProperties;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  styleLabel?: React.CSSProperties;
  label: string;
  icon?: React.ReactNode;
  endIcon?: React.ReactNode;
  tooltip?: string;
}

function ButtonLoading({
  isDelete,
  style,
  className,
  loading,
  disabled,
  onClick,
  styleLabel,
  label,
  icon,
  endIcon,
  tooltip,
}: ButtonLoadingProps) {
  const defaultStyle = {
    marginTop: "20px",
    width: "100%",
    height: "48px",
    borderRadius: "8px",
    backgroundColor: isDelete ? colors.white : colors.primary,
    color: isDelete ? "red" : colors.white,
    border: isDelete ? "1px solid red" : "none",
  };

  return (
    <Box>
      <Tooltip title={tooltip}>
        <Button
          variant={isDelete ? "text" : "contained"}
          className={className}
          style={{
            ...defaultStyle,
            ...style,
            opacity: loading || disabled ? 0.5 : 1,
          }}
          type={onClick ? "button" : "submit"}
          disabled={loading || disabled}
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          {icon}
          <span style={styleLabel ? styleLabel : undefined}>{label}</span>
          {endIcon}

          {loading && (
            <CircularProgress
              size={24}
              sx={{
                marginLeft: "12px",
                color: "#FFFFFF",
              }}
            />
          )}
        </Button>
      </Tooltip>
    </Box>
  );
}

export default ButtonLoading;
